
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Project_Activity } from '@/generated/graphql';
import DeleteIcon from "@/components/icons/DeleteNew.vue";
import UiButton from '@/components/button/ui-button.vue';
import GET_PROJECT_BY_ACTIVITY_ID from "@/apollo/projectActivities/GetProjectIdByActivityId.gql";
import DELETE_PROJECT_ACTIVITY from "@/apollo/projectActivities/DeleteActivity.gql";
import DELETE_PROJECT_ACTIVITY_SIMPLE from "@/apollo/projectActivities/DeleteActivitySimple.gql";
import Message from "@/data/notificationsMessages";
import { NOTIFICATION } from "@/entities/Events";

@Component({
  components: {
    UiButton,
    DeleteIcon,
  },
})
export default class DeleteTask extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserRole!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, default: undefined })
  readonly projectActivity?: Project_Activity;

  modalShown: boolean = false;
  isHovered: boolean = false;

  async onRemove(): Promise<void> {
    try {
      this.$confirm({
        title: "Remove visit",
        message: `Are you sure you want to remove this visit?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm: boolean) => {
          if (confirm) {
            const clientId = await this.fetchClientId();
            if (clientId) {
              await this.removeActivityById(this.projectActivity!.id, clientId);
              this.$eventBus.emit(
                NOTIFICATION,
                Message.successMessage("Visit was deleted successfully.")
              );
              window.location.reload();
              // this.$emit("visitDeleted");
            } else {
              this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage("Failed to retrieve project ID.")
              );
            }
          }
        },
      });
    } catch (e) {
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(e.message));
    }
  }
  async fetchClientId(): Promise<string | null> {
    try {
      const response = await this.$apollo.query({
        query: GET_PROJECT_BY_ACTIVITY_ID,
        variables: {
          activityId: this.projectActivity?.id,
        },
      });
      return response?.data?.project[0]?.id || null;
    } catch (error) {
      console.error("Failed to fetch client ID:", error);
      return null;
    }
  }

  async removeActivityById(id: string, clientId: string): Promise<void> {
    try {
      if (!id || !clientId) {
        console.log("Invalid IDs provided for deletion", { id, clientId });
        throw new Error("Activity ID and Project ID are required");
      }
      console.debug("Deleting activity with IDs:", { id, clientId, contractorId: this.projectActivity?.contractor_id });
      
      const contractorId = this.projectActivity?.contractor?.user?.id;
      
      if (contractorId) {
        // Use full deletion with document access cleanup for activities with contractors
        await this.$apollo.mutate({
          mutation: DELETE_PROJECT_ACTIVITY,
          variables: {
            id,
            projectId: clientId,
            contractorId: contractorId,
          },
        });
      } else {
        // Use simple deletion for draft activities or activities without contractors
        await this.$apollo.mutate({
          mutation: DELETE_PROJECT_ACTIVITY_SIMPLE,
          variables: {
            id,
          },
        });
      }
    } catch (error) {
      console.debug("Error deleting activity:", error);
      this.$eventBus.emit(NOTIFICATION, Message.errorMessage(error.message));
    }
  }
}
